import { FromEventPatternObservable } from './FromEventPatternObservable';
export var fromEventPattern = FromEventPatternObservable.create;
//# sourceMappingURL=fromEventPattern.js.map